import { ReactNode, useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { ImagenType } from "../components/Slider/Slider";
import { useTranslation } from "react-i18next";

interface ModalImageProps { image?: ImagenType; images?: ImagenType[]; children?: ReactNode; isOpen: boolean; toggle: () => void; closeModal: () => void; }

const ModalImage = ({ isOpen, image, images = [], closeModal }: ModalImageProps) => {
  const { t } = useTranslation();
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => { if (image) setCurrentIndex(Math.max(0, images.indexOf(image))); }, [image, images]);
  useEffect(() => {
    if (!isOpen) return;
    const keydown = (event: KeyboardEvent) => { if (event.key === "Escape") closeModal(); if (event.key === "ArrowRight") setCurrentIndex(index => (index + 1) % images.length); if (event.key === "ArrowLeft") setCurrentIndex(index => (index - 1 + images.length) % images.length); };
    document.addEventListener("keydown", keydown); document.body.style.overflow = "hidden";
    return () => { document.removeEventListener("keydown", keydown); document.body.style.overflow = ""; };
  }, [isOpen, images.length, closeModal]);
  if (!isOpen || !images.length) return null;
  const actualImage = images[currentIndex];
  if (!actualImage) return null;
  return createPortal(<div className="modal-overlay" role="dialog" aria-modal="true" aria-label={t("gallery.dialog")} onClick={closeModal}>
    <div className="modal-box" onClick={event => event.stopPropagation()}>
      <button className="modal-close" type="button" onClick={closeModal} aria-label={t("gallery.close")}>×</button>
      <button className="modal-arrow modal-arrow--left" type="button" onClick={() => setCurrentIndex((currentIndex - 1 + images.length) % images.length)} aria-label={t("gallery.previous")}>←</button>
      <img className="modal-image" src={actualImage.src} alt={t("gallery.imageAlt", { name: actualImage.text })} />
      <button className="modal-arrow modal-arrow--right" type="button" onClick={() => setCurrentIndex((currentIndex + 1) % images.length)} aria-label={t("gallery.next")}>→</button>
      <span className="modal-count">{currentIndex + 1} / {images.length}</span>
    </div>
  </div>, document.body);
};

export default ModalImage;
